import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { ReportedError } from './reported-error.model';

@Injectable({
  providedIn: 'root'
})
export class GlobalErrorHandlingService {

  private readonly errorReportingUrl = 'reported-errors/';

  constructor(private readonly http: HttpClient) {
  }

  reportErrorOnServer(error: ReportedError) {
    return this.http.post<ReportedError>(this.errorReportingUrl, error, {headers: {'Content-Type': 'application/json'}});
  }

}
